"use strict";

exports.__esModule = true;
exports["default"] = stringify;

function stringify(x) {
  try {
    // handle "Converting circular structure to JSON" error
    return JSON.stringify(x);
  } catch (e) {
    return String(x);
  }
}

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/revenge/lib/stringify.js
// module id = 566
// module chunks = 0